<div class="patient-actions-group" (click)="$event.stopPropagation()">
  <button
    class="patient-actions-btn btn-record"
    (click)="viewPatientRecord()"
    title="View Patient Record"
  >
    <i class="bi bi-person-badge"></i>
  </button>
  <span class="divider"></span>
  <button
    *ngIf="orderCount > 0"
    class="patient-actions-btn btn-orders"
    (click)="viewOrders()"
    [title]="orderCount + ' order' + (orderCount === 1 ? '' : 's')"
  >
    <span class="orders-icon-wrap">
      <i class="bi bi-bag"></i>
      <span class="orders-count">{{ orderCount }}</span>
    </span>
  </button>
  <span *ngIf="orderCount > 0" class="divider"></span>
  <button
    class="patient-actions-btn btn-ai"
    (click)="analyzeWithAi()"
    title="Analyze with AI"
  >
    <i class="bi bi-robot"></i>
  </button>
</div>
